/* eslint-disable react/jsx-quotes */
/* eslint-disable react/jsx-sort-prop-types */

import Axios from "axios";
import { ID_TOKEN } from "./authutils";
import { AppAPIKey } from "./domain";

const getV2AxiosInstance = () => {
  return Axios.create({
    baseURL: "https://apiv2.invoxcontact.com/",
    headers: {
      "x-api-key": AppAPIKey,
      "authorization": `Bearer ${localStorage.getItem(ID_TOKEN)}`,
    },
  });
};

export default getV2AxiosInstance;



// WEBPACK FOOTER //
// ./src/utils/v2Axios.js.js